import Vue from 'vue'
import CampaignFrontpageTop from '@/components/CampaignFrontpageTop'
import CampaignSquare from '@/components/CampaignSquare'
import CampaignMedium from '@/components/CampaignMedium'
import CampaignNoPic from '@/components/CampaignNoPic'
import CampaignNoText from '@/components/CampaignNoText'
import ChapterDropdown from '@/components/ChapterDropdown'
import DocumentRef from '@/components/DocumentRef'
import Donate from '@/components/Donate'
import FrontpageIssueList from '@/components/FrontpageIssueList'
import IssueSearch from '@/components/IssueSearch'
import IssueList from '@/components/IssueList'
import GoogleFormBlock from '@/components/GoogleFormBlock'
import Group from '@/components/Group'
import HeroJerkBlock from '@/components/HeroJerkBlock'
import ImageBlock from '@/components/ImageBlock'
import LinksBlock from '@/components/LinksBlock'
import NewsList from '@/components/NewsList'
import PersonCard from '@/components/PersonCard'
import TextBlock from '@/components/TextBlock'
import PersonSearch from '@/components/PersonSearch'

const BlockRender = Vue.component('block-render', {
  functional: true,
  render: function (createElement, context) {
    var blocks = context.props.blocks
    var elements = []
    var textBlocks = []

    // Loop through all the blocks, create new element for each component
    // and add them to the elements array which will be output in a new div
    blocks.forEach((block, index) => {
      // var prev = block[index-1]
      var next = blocks[index + 1]
      // console.log(block._type)
      switch (block._type) {
        case 'block':
          if (!next || next._type !== 'block') {
            textBlocks.push(block)
            elements.push(createElement(TextBlock, {
              props: {
                blocks: textBlocks,
                wrapClasses: context.props.textWrapClasses
              }
            }))
            textBlocks = []
          } else {
            textBlocks.push(block)
          }
          break

        case 'documentRef':
          elements.push(createElement(DocumentRef, {
            props: {
              document: block.document,
              wrapClasses: context.props.textWrapClasses
            }
          }))
          break

        case 'donate':
          elements.push(createElement(Donate, {
            props: {
              text: block.text
            }
          }))
          break

        case 'personBlock':
          elements.push(createElement(PersonCard, {
            props: {
              role: block.role,
              person: block.person,
              wrap: 'column is-8 is-7-widescreen is-offset-2 is-paddingless-mobile'
            }
          }))
          break

        case 'campaign_frontpage_top':
          elements.push(createElement(CampaignFrontpageTop, {
            props: {
              text: block.text,
              link: block.link_to,
              linkText: block.link_text,
              imageUrl: block.image
            }
          }))
          break

        case 'campaign':
          switch (block.viewType) {
            case 'Medium':
              elements.push(createElement(CampaignMedium, {
                props: {
                  text: block.title,
                  link: block.link,
                  linkText: block.title,
                  imageUrl: block.image.asset.url,
                  ctaText: block.cta
                }
              }))
              break

            case 'Kvadrat':
              elements.push(createElement(CampaignSquare, {
                props: {
                  text: block.title,
                  link: block.link,
                  linkText: block.title,
                  imageUrl: block.image.asset.url,
                  ctaText: block.cta
                }
              }))
              break

            case 'Kun bilde':
              elements.push(createElement(CampaignNoText, {
                props: {
                  link: block.link,
                  imageUrl: block.image.asset.url
                }
              }))
              break

            case 'Kun tekst':
              elements.push(createElement(CampaignNoPic, {
                props: {
                  link: block.link,
                  text: block.title,
                  ctaText: block.cta
                }
              }))
              break
          }
          break

        case 'googleForm':
          elements.push(createElement(GoogleFormBlock, {
            props: {
              url: block.url
            }
          }))
          break

        case 'group':
          elements.push(createElement(Group, {
            props: {
              title: block.title,
              members: block.members
            }
          }))
          break

        case 'heroJerkBlock':
          elements.push(createElement(HeroJerkBlock, {
            props: {
              hero: block.hero,
              jerk: block.jerk
            }
          }))
          break

        case 'frontPageIssueList':
          elements.push(createElement(FrontpageIssueList, {
            props: {
              issues: block.frontPageIssues
            }
          }))
          break

        case 'issueList':
          elements.push(createElement(IssueList))
          break

        case 'issueSearchBlock':
          elements.push(createElement(IssueSearch))
          break

        case 'linksBlock':
          elements.push(createElement(LinksBlock, {
            props: {
              links: block.links
            }
          }))
          break

        case 'lagFinderBlock':
          elements.push(createElement(ChapterDropdown, {
            props: {
              title: block.title
            }
          }))
          break

        case 'personSearchBlock':
          elements.push(createElement(PersonSearch, {
            props: {
              title: block.title
            }
          }))
          break

        case 'newsBlock':
          elements.push(createElement(NewsList))
          break

        case 'rodtImage':
          elements.push(createElement(ImageBlock, {
            props: {
              caption: block.caption,
              imageUrl: block.image.asset.url,
              size: block.imageSize
            }
          }))
          break
      }
    })
    return createElement('div', {style: {width: '100%'}}, elements)
  //   [
  //   createElement('h1', 'hello world'),
  //   createElement(MyComponent, {
  //     props: {
  //       someProp: 'foo'
  //     }
  //   }),
  //   'bar'
  // ]
    // function appropriateListComponent () {
    //   var items = context.props.items
    //   if (items.length === 0)           return EmptyList
    //   if (typeof items[0] === 'object') return TableList
    //   if (context.props.isOrdered)      return OrderedList
    //   return UnorderedList
    // }
    // return createElement(
    //   appropriateListComponent(),
    //   context.data,
    //   context.children
    // )
  },
  props: {
    textWrapClasses: String,
    blocks: {
      type: Array
    },
    isOrdered: Boolean
  },
  name: 'blockrender'
})

export default BlockRender



// WEBPACK FOOTER //
// ./src/components/BlockRender.js